export const quickBooksConnectionStatus = {
  Connected: 'Connected'
}
